'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');
var components_Title2_index = require('../Title2/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Container = styled__default["default"].li(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  cursor: default;\n  padding: 6px 16px;\n  text-align: left;\n"], ["\n  cursor: default;\n  padding: 6px 16px;\n  text-align: left;\n"])));
var LabelText = styled__default["default"](components_Title2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject([""], [""])));
var MenuLabel = function (_a) {
    var children = _a.children, className = _a.className;
    return (React__default["default"].createElement(Container, { className: className },
        React__default["default"].createElement(LabelText, null, children)));
};
var templateObject_1, templateObject_2;

exports["default"] = MenuLabel;
